import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  ventas: any;
  morosos = [];
  retraso: number;
  cont = 0;
  solicitudes = 0;
  usr: {};
  constructor(private prodSvc: ProductosService,
              private authSvc: AuthService,
              private route: Router) { }

  ngOnInit(): void {
    this.prodSvc.cargarPedidosPendientes()
    .subscribe(res => {
      this.cont = res.length;
    });

    this.authSvc.cargarDistribuidoresPendientes()
                .subscribe(res => {
                  this.solicitudes = res.length;
                });
  }

  onLogout(){
    Swal.fire({
      title: 'Salir del administrador?',
      text: 'Vas a cerrar tu sesión?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, cerrar'
    }).then((result) => {
      if (result.value) {
        try {
          this.authSvc.logout();
          this.route.navigate(['home']);
          // window.location.href = 'https://supedido.co/';
        } catch (error) {
          console.log(error);
        }
        Swal.fire(
          'Sesión finalizada!',
          'Te esperamos de nuevo.',
          'success'
        );
      }
    });
   }

}
